import { Observable } from 'rxjs';
import { MediaBreakpoint } from './breakpoints';

export abstract class MatchMediaService {
	abstract get activeMediaQuery(): MediaBreakpoint;
	abstract media$: Observable<MediaBreakpoint>;
	abstract isActive(...breakPoint: MediaBreakpoint[] | string[]): boolean;
	abstract destroy(): void;
}
